var JoyStatus;
(function (JoyStatus) {
    JoyStatus["created"] = "created";
    JoyStatus["processed"] = "processed";
    JoyStatus["deleted"] = "deleted";
})(JoyStatus || (JoyStatus = {}));
export default JoyStatus;
//# sourceMappingURL=JoyStatus.js.map